import script from "./esWeekModelSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./esWeekModelSettings.vue?vue&type=script&setup=true&lang=ts"

import "./esWeekModelSettings.vue?vue&type=style&index=0&id=1839fae8&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1839fae8"]])

export default __exports__